import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Header, Container, Grid } from 'semantic-ui-react';
import SignupFormWrapper from './../SignupFormWrapper';
import Logo from './../Logo';

import * as styles from './SignupForm.less';

const calendlyScript = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://assets.calendly.com/assets/external/widget.js';
  return script;
};

const calendly = thankYou => {
  const element = document.createElement('div');
  element.className = 'calendly-inline-widget';
  element.setAttribute(
    'data-url',
    `https://calendly.com/copytesting/demo/?${thankYou}`,
  );
  element.style = 'margin-top:50px;min-width:320px;height:630px;';
  return element;
};

const SignupForm = ({ register }) => {
  const [thankYou, setThankYou] = useState('');
  useEffect(() => {
    if (thankYou) {
      document.getElementById('calendly').appendChild(calendly(thankYou));
      document.getElementById('calendly').appendChild(calendlyScript());
    }
  }, [thankYou]);

  return thankYou ? (
    <Container className={styles.calendly} id='calendly' textAlign='center'>
      <h1>Book a demo call</h1>
      <p>We'll guide you through the app and get you set up in 30 minutes.</p>
    </Container>
  ) : (
    <Container className={styles.signupFormWrapper}>
      <Grid className={styles.signupForm} columns={2} doubling>
        <Grid.Column width={6} className={styles.leftSideWrapper}>
          <div className={styles.leftSideContent}>
            <Logo size='small' />
            <Header as='h3' className={styles.header}>
              Create your account
            </Header>
            <p className={styles.subHeader}>No credit card required.</p>
          </div>
        </Grid.Column>
        <Grid.Column width={10} className={styles.rightSideWrapper}>
          <Form>
            <SignupFormWrapper register={register} setThankYou={setThankYou} />
          </Form>
        </Grid.Column>
      </Grid>
    </Container>
  );
};

SignupForm.propTypes = {
  register: PropTypes.func,
};

export default SignupForm;



// WEBPACK FOOTER //
// ./src/views/components/SignupForm/SignupForm.js